import type { FoundWord } from "../dataLayer/backendApi";

export interface FriendWordComparison {
  missed: FoundWord[];
  shared: FoundWord[];
  onlyYou: FoundWord[];
}

export function compareFriendWords(
  friendWords: FoundWord[],
  ownWords: string[],
): FriendWordComparison {
  const ownWordSet = new Set(ownWords.map((word) => word.toUpperCase()));
  const friendWordSet = new Set(friendWords.map((word) => word.word.toUpperCase()));
  return friendWords.reduce<FriendWordComparison>(
    (comparison, word) => {
      const group = ownWordSet.has(word.word.toUpperCase()) ? comparison.shared : comparison.missed;
      group.push(word);
      return comparison;
    },
    {
      missed: [],
      shared: [],
      onlyYou: [...ownWordSet]
        .filter((word) => !friendWordSet.has(word))
        .map((word) => ({ word, rating: null })),
    },
  );
}
